import Vue from 'vue'
import Vuex from 'vuex'
import menu from './menu'
import editorStore from './editorStore'
import editorCollection from './editorCollection'
import editorDetail from './editorDetail'
import user from './user'
import order from './order'
import email from './email'
import message from './message'
import products from './products'
import { getFolders } from '../server/dashboard'
import { isComplete, isUserComplete } from '../server/user'
import { getMerchantShopList } from '../server/business'
import Cookies from 'js-cookie'
import { setSession, getSession, _local } from '@/utils/storage'
import { cloneDeep } from '../utils'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    doms: [],
    isAllScreen: false,
    dataColors: ['#0560FD', '#13C2C2', '#68D287', '#9BEA2D', '#FAD337', '#FF7C00', '#E71B21', '#F2637B', '#975FE4', '#3BCAF6', '#3A416F'],
    dictionaries: {},
    bindShopModalShow: false, // 店铺窗口
    updateReportData: null, // 更新或者新建的报表数据，优化防止刷新整个报表，提升性能。
    boardDataList: [], //打开的看板数据列表
    searchList: [],
    menuList: {}, //菜单列表
    siteList: [],
    pageVisable: false,
    bindShopCallbackFn: null,
    language: ''
  },
  mutations: {
    changeLanguage(state, data) {
      state.language = data
      Cookies.set('language', data, { domain: process.env.VUE_APP_ENV === 'dev' ? window.location.hostname : process.env.VUE_APP_DOMAIN, expires: 7 })
    },
    pushDoms(state, data) {
      state.doms.push(data)
    },
    removeDoms(state, data) {
      state.doms = state.doms.filter(item => item.target !== data.target)
    },
    setLanguage(state, data) {
      state.language = data
      setSession('language', data)
    },
    setVisable(state, data) {
      state.pageVisable = data
    },
    setShopVisiable(state, data) {
      console.log(data, '授权店铺')
      state.bindShopModalShow = data.visiable
      state.bindShopCallbackFn = data.fn
    },
    setDictionaries(state, data) {
      state.dictionaries = Object.assign(state.dictionaries, data)
    },
    setBoardList(state, data) {
      state.boardDataList = data
    },
    setSiteList(state, data) {
      state.siteList = data
    },
    setScreen(state, bool) {
      state.isAllScreen = bool
    },
    sortList(state, data) {
      console.log(state.siteList.length)
      const current = state.siteList.find(i => i.id === data.id)
      const list = state.siteList.filter(i => i.id !== data.id)
      console.log(current, list, data.type)
      if (current) {
        if (data.type === 0) {
          state.siteList = [current, ...list]
        } else {
          state.siteList = [...list, current]
        }
      }
    }
  },
  actions: {
    //  1.02版本 废弃
    async getMenu({ state }, params = {}) {
      const res = await getFolders()
      if (res.status == 200) {
        // 完成后端层级
        res.result.topFolders.map((v, i) => {
          v.folders = [...cloneDeep(res.result.pubFolders[i].folders)]
          return v
        })
        state.menuList = res.result
      }

    },
    async getMerchant(store, update) {
      if (_local.get('merchantList') && !update) {
        const data = _local.get('merchantList')
        store.commit('user.setMerchantList', data)
        if (data[0] && !store.state.user.merchantId) {
          store.commit('user.setMerchantId', data[0].userId)
        }
      } else {
        const res = await getMerchantShopList()
        if (res.data.code == 0) {
          _local.set('merchantList', res.data.data)
          store.commit('user.setMerchantList', res.data.data)

          if (res.data.data[0] && !store.state.user.merchantId) {
            store.commit('user.setMerchantId', res.data.data[0].userId)
          }
        }
      }

    },
    async getBindData(store, params = {}) {
      let status = {}
      if (_local.get('merchantId')) {
        const [data, res] = await Promise.all([
          isComplete(),
          isUserComplete()
        ]);
        if (data.data.code === 0) {
          status = { ...status, ...data.data.data }
          if (store.state.user.sourceType === 2) {
            delete status.isExistShop
          }
          store.commit('user.sethasBindData', status)
          _local.set('hasBindData', status)
        }
        if (res.data.code === 0) {
          status = { ...status, ...res.data.data }
          delete status.sourceType
          store.commit('user.sethasBindData', status)
          _local.set('hasBindData', status)
        }
      }

    },
    async getUserList({ state }) {
      const res = await new Promise((resolve, reject) => {
        getAllUsers().then((res) => {
          resolve(res)
        })
      })
      state.userList = res.result
    },
    async refreshShopList({ state }) {
      if (state.getShopListFn) {
        await state.getShopListFn()
        // state.getShopListFn = null
      }
    }
  },
  modules: {
    menu,
    editorStore,
    editorCollection,
    editorDetail,
    user,
    message,
    order,
    email,
    products
  }
})
